export default {
  path: "/user/notificaciones-email",
  component: () =>
    import("@/views/user/notificaciones/NotificacionesEmailLayout.vue"),
  meta: {
    requiresAuth: true,
    requiresCurso: true,
    requiresDirectiva: true,
  },
  children: [
    {
      path: "",
      name: "notificaciones-email-list",
      component: () =>
        import("@/views/user/notificaciones/NotificacionesEmailListView.vue"),
    },
    {
      path: ":emailDispatchId",
      name: "notificaciones-email-detalle",
      component: () =>
        import(
          "@/views/user/notificaciones/NotificacionesEmailDetalleView.vue"
        ),
      props: true,
    },
  ],
};
